import { FormattedMessage } from 'react-intl';

import { AccountCreation } from '@/components/signup/account-creation/account-creation';
import { Social } from '@/components/signup/account-creation/components/social/social';
import { JiraOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { FeatureExposed } from '@/utils/feature-exposed/use-feature-exposed';

import { GetStartedText } from '../../../components/get-started-heading';
import { Headings } from '../../../components/headings';
import { InputSubmitButton } from '../../../components/submit-input';

export const LoggedOutJiraFree = () => {
	return (
		<FeatureExposed experimentKey="jfind-1565-sign-up-flow-overlay" group="Test">
			<JiraOverlayTemplate size="sm">
				<Headings
					main={<GetStartedText productName="Jira" />}
					sub={
						<FormattedMessage
							id="signupForm.accountCreation.subHeaderText"
							defaultMessage="It’s free for up to 10 users - no credit card needed."
						/>
					}
				/>
				<FeatureExposed experimentKey="jfind-1185-signup-button-update" group="Test">
					<AccountCreation Input={<InputSubmitButton />} Social={<Social />} Submit={null} />
				</FeatureExposed>
			</JiraOverlayTemplate>
		</FeatureExposed>
	);
};
